import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export function EndDateTimeDialog({
  open,
  onClose,
  dateEnd,
  timeEnd,
  onDateEndChange,
  onTimeEndChange,
  onClear,
  onAccept,
  title = "Fecha y hora final",
  dateLabel = "dateEnd",
  timeLabel = "timeEnd",
  cancelLabel = "Cancelar",
  clearLabel = "Limpiar",
  acceptLabel = "Aceptar",
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label={dateLabel}
              inputFormat="DD/MM/YYYY"
              name="dateEnd"
              value={dateEnd}
              onChange={onDateEndChange}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileTimePicker
              label={timeLabel}
              value={timeEnd}
              name="timeEnd"
              onChange={onTimeEndChange}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button type="button" variant="contained" color="error" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button
          type="button"
          variant="contained"
          color="warning"
          onClick={onClear}
        >
          {clearLabel}
        </Button>
        <Button
          type="button"
          variant="contained"
          color="secondary"
          onClick={onAccept}
        >
          {acceptLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
